import { gql } from "generated-graphql";

export const GET_STAFF_TENANT_SUBSCRIPTIONS = gql(`
  query StaffTenantSubscriptions(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    staffTenantSubscriptions(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        tenantId
        tenantName
        salesforceAccountId
        isDemo
        isPartner
        isDisabled
        customerEngagementTier
        chemicalServiceTier
        wasteServiceTier
        epcraSubscriptionStatus
        rcraSubscriptionStatus
        insightsSubscriptionStatus
        calendarSubscriptionStatus
        chemicalsDataPipeline
        contractedIntelligencePlatformFacilities
        contractedInsightsFacilities
        contractedChemicalSubscriptionFacilities
        contractedChemicalReportingFacilities
        contractedWasteSubscriptionFacilities
        contractedWasteReportingBiennialFacilities
        contractedWasteReportingNonBiennialFacilities
        actualChemicalFacilities
        actualWasteFacilities
        actualPlatformFacilities
        chemicalStatus
        wasteStatus
      }
      count
      stats {
        totalTenants
        chemicalOverages
        wasteOverages
        chemicalWithinLimit
        totalContractedPlatformFacilities
      }
      lastSyncedAt
    }
  }
`);
